import { DiscoveryType, JoinedDiscoveryData } from '@hud/portal-dtos/webapp-overview.dto';
import { useGlobalQueryString } from '../../hooks/useGlobalFilter';
import { HudIcon, IconType } from '@hud/web-components/Icons/HudIcons';
import DiscoveryTable from '@hud/web-components/DesignSystem/Components/DiscoveryPage/DiscoveryTable/DiscoveryTable';
import Tooltip from '@hud/web-components/DesignSystem/Components/Tooltip/Tooltip';
import { sortDiscoveryData } from './utils/sortDiscoveryData';

type DiscoveryTableRendererProps = {
  isLoading: boolean;
  title: string;
  tooltip?: string;
  icon?: IconType;
  data: JoinedDiscoveryData;
  discoveryType: DiscoveryType;
  shouldShowServices: boolean;
};

export default function DiscoveryTableRenderer({
  isLoading,
  discoveryType,
  title,
  tooltip,
  data,
  icon,
  shouldShowServices,
}: DiscoveryTableRendererProps) {
  const sortedData = sortDiscoveryData(data, discoveryType);
  const globalQueryString = useGlobalQueryString();

  return (
    <div className="tableContainer">
      <Tooltip label={tooltip} >
        <div className="title">
          <HudIcon icon={icon as IconType} size="20px" /> {title}
        </div>
      </Tooltip>
      <DiscoveryTable
        isLoading={isLoading}
        data={sortedData}
        discoveryType={discoveryType}
        globalQueryString={globalQueryString}
        shouldShowServices={shouldShowServices}
      />
    </div>
  );
}
